import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
    state: () => ({
        theme: 'light', // 'light' | 'dark'
    }),

    getters: {
        isDark: (s) => s.theme === 'dark',
    },

    actions: {
        // Apply the <html> class from current state (call on client mount & after toggles)
        applyHtmlClass() {
            if (typeof document !== 'undefined') {
                document.documentElement.classList.toggle('dark', this.theme === 'dark')
            }
        },
        toggle() {
            this.theme = this.theme === 'dark' ? 'light' : 'dark'
            this.applyHtmlClass()
        },

        // Optional: initialize from a server-provided hint, then apply class
        initFrom(localeProps = {}) {
            // no-op here; persistence will hydrate automatically
            // but you can read a server hint if you pass one:
            // if (localeProps.theme) this.theme = localeProps.theme
            this.applyHtmlClass()
        },
    },

    // Persist only what you need
    persist: {
        key: 'theme',
        paths: ['theme'],
        // Default is localStorage; see "Cookie strategy" below for SSR-friendly hints
    },
})